const dateRender = (datetime: string) => {
  const format = new Intl.DateTimeFormat('en-US',
    {month: 'long', day: 'numeric', year: 'numeric'}
  );

  return format.format(new Date(datetime));
}

export default dateRender;
